import { useEffect, useRef, useState } from "react";
import { CourseCards } from "./CourseCards";
import { useTranslation } from "react-i18next";
import { SliderBigIMG } from "./SliderBigIMG";
import { Preloader } from "./Preloader";
import "./AboutUs.css";
import { useAppTranslation } from "./TranslationContext";
import { preloadImages, fontsReady, windowLoaded, withTimeout } from "../utils/preload";

export const Primary = () => {
  const { i18n } = useTranslation();
  const { t } = useAppTranslation();

  const [slidesData, setSlidesData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const autoSlideTimeout = useRef(null);

  // показываем прелоадер 1 раз за сессию
  const [showPreloader, setShowPreloader] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("preloaderSeen");
  });
  const [ready, setReady] = useState(false);

  const goToSlide = (index) => setCurrentSlide(index);

  // 1) грузим данные
  useEffect(() => {
    let cancelled = false;

    const loadAll = async () => {
      try {
        // Блок 1: ждём «окно/шрифты», но не дольше 8–10 секунд
        await Promise.all([
          withTimeout(windowLoaded(), 6000),
          withTimeout(fontsReady(), 6000),
        ]);

        // Блок 2: API
        const res = await fetch("https://api.rasulova-academy.uz/api/main/");
        const data = await res.json();
        if (cancelled) return;

        const slides = Array.isArray(data) ? data : [data];
        const lang = i18n.language;

        const mapped = slides.map((item) => ({
          hero: item["img_uz"] || item.img_uz,
          bg: "/images/Group 3.png",
          quote: item[`comment_${lang}`] || item.comment_uz,
          name: item[`yunalish_${lang}`] || item.yunalish_uz,
        }));

        setSlidesData(mapped);

        // Блок 3: предзагрузка критичных изображений (с таймаутом, чтобы не зависнуть)
        const criticalLocal = [
          "/images/Group 3.png",
          "/images/1.gif",
          "/images/2.gif",
          "/images/3.gif",
          "/images/4.gif",
        ];
        const author = "https://api.rasulova-academy.uz/media/IMG_0952.JPG";
        const heroes = mapped.map((s) => s.hero).filter(Boolean);

        await withTimeout(preloadImages([...criticalLocal, author, ...heroes]), 7000);
      } catch (e) {
        // не падаем из-за ошибок загрузки
        console.warn("Loader warning:", e);
      } finally {
        if (!cancelled) setReady(true);
      }
    };

    loadAll();
    return () => {
      cancelled = true;
    };
  }, [i18n.language]);

  // 2) авто-слайд
  useEffect(() => {
    if (slidesData.length === 0) return;
    autoSlideTimeout.current = setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slidesData.length);
    }, 9000);
    return () => clearTimeout(autoSlideTimeout.current);
  }, [currentSlide, slidesData]);

  return (
    <>
      {showPreloader && (
        <Preloader
          ready={ready}
          onFinish={() => {
            sessionStorage.setItem("preloaderSeen", "1");
            setShowPreloader(false);
          }}
          // minShowMs={800} // по желанию
        />
      )}

      <div className="primary" aria-hidden={showPreloader ? "true" : "false"}>
        <div className="primary__content">
          <h1 className="primary__title">{t("primaryTitle")}</h1>
          <p className="primary__subtitle">{t("primarySubtitle")}</p>
        </div>

        <div className="slider">
          <div className="slides">
            {slidesData.map((slide, index) => (
              <div key={index} className={`slide ${index === currentSlide ? "active" : ""}`}>
                <img className="slide__hero" src={slide.hero} alt={`Character ${index + 1}`} />
                <img className="slide__bg" src={slide.bg} alt="" />
                <div className="slide__content">
                  <div className="slide__content-title">{t("ourTeachers")}</div>
                  <div className="quote">{slide.quote}</div>
                  <div className="name">{slide.name}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dots" id="dots">
            {slidesData.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>

      <CourseCards />
      <SliderBigIMG />

      <div className="about-page">
        <section className="features">
          <h2 className="prim__title">{t("whyWe")}</h2>
          <ul className="features-list">
            <li className="features-item">
              <img src="/images/1.gif" alt="" />
              <span>{t("why1")}</span>
            </li>
            <li className="features-item">
              <img src="/images/2.gif" alt="" />
              <span>{t("why2")}</span>
            </li>
            <li className="features-item">
              <img src="/images/3.gif" alt="" />
              <span>{t("why3")}</span>
            </li>
            <li className="features-item">
              <img src="/images/4.gif" alt="" />
              <span>{t("why4")}</span>
            </li>
          </ul>
        </section>

        <section className="author">
          <h2 className="prim__title">{t("author")}</h2>
          <div className="author-block">
            <img
              src="https://api.rasulova-academy.uz/media/IMG_0952.JPG"
              alt="author"
              className="author-img"
              loading="eager"
            />
            <div className="author-content">
              <p className="author-name">{t("authorName")}</p>
              <p className="author-deg">{t("authoeDeg")}</p>
              <p className="author-desc">{t("authorDesc")}</p>
              <br />
              <div className="author-desc">{t("authorDesc2")}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
